/**
 * Email Verification Page
 */

import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { verifyEmail } from '../services/authService';
import '../styles/auth.css';

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Ungültiger oder fehlender Verifizierungstoken');
      return;
    }

    // Verify email
    verifyEmail(token)
      .then((data) => {
        setStatus('success');
        setMessage(data.message || 'E-Mail erfolgreich bestätigt!');
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/#lab-auth');
        }, 3000);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'Verifizierung fehlgeschlagen');
      });
  }, [token, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        {status === 'loading' && (
          <div className="auth-status-card">
            <div className="auth-loader"></div>
            <h2>E-Mail wird verifiziert...</h2>
            <p>Bitte warten Sie einen Moment</p>
          </div>
        )}

        {status === 'success' && (
          <div className="auth-success-card">
            <div className="auth-success-icon">
              <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            </div>
            <h2>E-Mail bestätigt!</h2>
            <p>{message}</p>
            <p className="auth-redirect-notice">
              Sie werden in wenigen Sekunden zur Anmeldeseite weitergeleitet...
            </p>
            <Link to="/#lab-auth" className="auth-button" style={{ marginTop: '1rem' }}>
              Jetzt anmelden
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="auth-error-card">
            <div className="auth-error-icon">
              <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
            </div>
            <h2>Verifizierung fehlgeschlagen</h2>
            <p>{message}</p>
            <div className="auth-error-actions">
              <Link to="/register" className="auth-button">
                Neu registrieren
              </Link>
              <Link to="/#lab-auth" className="auth-link-secondary">
                Zur Anmeldung
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
